import { ACC_VERIFICATION_STATUS, triggerSurveyForUnverifiedUserConfig } from '../constants/common';
import { PlayerSurveyEvents } from '../constants/datalayer';

export const triggerSurveyForUnverifiedUser = (registeredOn: number, verificationStatus: string) => {
	const isNotVerified = verificationStatus === ACC_VERIFICATION_STATUS.toCheck || verificationStatus === ACC_VERIFICATION_STATUS.temporary;
	if (!isNotVerified) return;
	const now = new Date();
	const allowToSendDataLayer =
		now.getTime() - registeredOn >= triggerSurveyForUnverifiedUserConfig.RUN_TRIGGER_AFTER_REGISTRATION_IN_DAYS * 24 * 60 * 60 * 1000;
	if (allowToSendDataLayer) {
		PlayerSurveyEvents.NOT_VERIFIED();
	}
};
